import { useGlobalState } from '../GlobalStateProvider'
import { deleteImage, uploadImage, getImage, getImageUploadUrl, uploadImageToS3, validateImage } from '../../services/imageCaptureService'
import { WRONG_IMAGE_TYPE_ERROR, FAILED_TO_UPLOAD_ERROR } from '../../constants/errors'
const useImageCaptureService = () => {
  const globalState = useGlobalState()

  const deleteSelectedImage = async ({ prospectId, category }) => {
    const result = await deleteImage({
      globalState,
      params: {
        id: prospectId,
        category: category
      }
    })
    return result && result.data ? result.data.isDeleted : false
  }

  const uploadSelectedImage = async imageFormData => {
    const result = await uploadImage({
      globalState,
      params: {
        formData: imageFormData
      }
    })
    var error = result.status === 400 ? WRONG_IMAGE_TYPE_ERROR : result.error ? FAILED_TO_UPLOAD_ERROR : false
    return { result: !result.error, error }
  }

  const getSelectedImageUploadUrl = async filename => {
    const result = await getImageUploadUrl({
      globalState,
      params: {
        filename: filename
      }
    })
    var error = result.status === 400 ? WRONG_IMAGE_TYPE_ERROR : result.error ? FAILED_TO_UPLOAD_ERROR : false
    return { isSuccess: result.status === 200, data: result.data, error }
  }

  const uploadSelectedImageToS3 = async imageFormData => {
    const result = await uploadImageToS3({
      params: imageFormData
    })
    return { isSuccess: result.status === 200, error: result.status !== 200 }
  }

  const validateSelectedImage = async params => {
    const result = await validateImage({
      globalState,
      params
    })
    var error = result.status === 400 ? WRONG_IMAGE_TYPE_ERROR : result.error ? FAILED_TO_UPLOAD_ERROR : false
    return { isSuccess: result.status === 200, data: result.data, error }
  }

  const getImages = async prospectId => {
    const result = await getImage({ globalState, params: { prospectId } })
    return result && result.data && result.data.data ? result.data.data.items : false
  }

  return {
    deleteImage: deleteSelectedImage,
    uploadImage: uploadSelectedImage,
    getAllImages: getImages,
    getImageUploadUrl: getSelectedImageUploadUrl,
    uploadImageToS3: uploadSelectedImageToS3,
    validateImage: validateSelectedImage
  }
}

export default useImageCaptureService
